@if (visible) {
  <mat-nav-list>
    <a class="cursorPointer" data-testid="emaac-alert-history-nav" (click)="openEmaacAlertHistory()">
      <mat-list-item
        class="text-light"
        [matTooltipDisabled]="showTitles"
        matTooltip="{{ 'ALERT_HISTORY' | translate }}"
        matTooltipPosition="after"
        matTooltipClass="navTooltipStyle"
        matTooltipShowDelay="50"
        matTooltipHideDelay="150">
        <div [ngClass]="{ centerItem: !showTitles }">
          <i class="fa-light fa-clock" aria-hidden="true"></i>
          @if (showTitles) {
            <span>{{ "ALERT_HISTORY" | translate }}</span>
          }
        </div>
      </mat-list-item>
    </a>
  </mat-nav-list>
}
